import UserResponse from "interfaces/response/UserResponse";
import Avatar from "../../components/common/Avatar";

interface Props {
  user: UserResponse | undefined;
  displayCrossIcon?: boolean;
}

export default function AccountAvatar(props: Props) {
  const { user, displayCrossIcon } = props;
  return (
    <Avatar
      firstName={user?.firstName || ""}
      lastName={user?.lastName || ""}
      displayCrossIcon={displayCrossIcon}
    />
  );
}
